module.exports = __webpack_public_path__ + "img/readerstar.77014d3d.png";